module.exports = __webpack_public_path__ + "static/img/120.065ea6a8.png";